import { j as o } from "../../../../node_modules/react/jsx-runtime.js";
import s from "../../LinkButton/LinkButton.js";
import { subDays as a } from "../../../../node_modules/date-fns/subDays.js";
import { endOfMonth as i } from "../../../../node_modules/date-fns/endOfMonth.js";
import { startOfWeek as l } from "../../../../node_modules/date-fns/startOfWeek.js";
import { endOfWeek as f } from "../../../../node_modules/date-fns/endOfWeek.js";
import { startOfMonth as n } from "../../../../node_modules/date-fns/startOfMonth.js";
import { startOfYear as c } from "../../../../node_modules/date-fns/startOfYear.js";
import { endOfYear as p } from "../../../../node_modules/date-fns/endOfYear.js";
const w = ({ onChange: e }) => {
  const t = /* @__PURE__ */ new Date(), m = [
    {
      label: "Last Week",
      onclick: () => e([l(a(t, 7)), f(a(t, 7))])
    },
    {
      label: "Last Month",
      onclick: () => e([n(t), i(t)])
    },
    {
      label: "Last Year",
      onclick: () => e([c(t), p(t)])
    }
  ];
  return /* @__PURE__ */ o.jsx("div", { className: " w-full flex items-center justify-between", children: m.map((r) => /* @__PURE__ */ o.jsx(
    s,
    {
      variant: "primary",
      size: "medium",
      label: r.label,
      onClick: r.onclick
    },
    r.label
  )) });
};
export {
  w as default
};
//# sourceMappingURL=PresetRange.js.map
